import Footer from "./footer";
import NavBar from "./navBar";

const Save =()=>{
    return (
        <>
         <header id="header" class="ex-2-header">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h1>Save Now</h1>
                   <p>Fill out the form below to make a deposit. Or <a class="white" href="#">Check Balance</a></p> 
                    <div class="form-container">
                        <form id="signUpForm" data-toggle="validator" data-focus="false">
                            <div class="form-group">
                                <input type="email" class="form-control-input" id="semail" required />
                                <label class="label-control" for="semail">Address: </label>
                                <div class="help-block with-errors"></div>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control-input" id="sname" required />
                                <label class="label-control" for="sname">Amount: </label>
                                <div class="help-block with-errors"></div>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control-input" id="spassword" required />
                                <label class="label-control" for="spassword">Purpose: </label>
                                <div class="help-block with-errors"></div>
                            </div>
                            <div class="form-group checkbox">
                                <input type="checkbox" id="sterms" value="Agreed-to-Terms" required/>I agree with coopxend's <a href="#">Privacy Policy</a> and <a href="#">Terms Conditions</a>
                                <div class="help-block with-errors"></div>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="form-control-submit-button">DEPOSIT</button>
                            </div>
                            <div class="form-message">
                                <div id="smsgSubmit" class="h3 text-center hidden"></div>
                            </div>
                        </form>
                    </div>

                </div> 
            </div>
        </div>
    </header> 
        </>
    )
}

export default Save;